import React, { FC } from 'react';
import { Card, useTheme, FormControlLabel, Radio, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckIcon from 'shared/components/check-icon/check-icon';

type ICheckBoxContainer = {
  disabled: boolean;
  language: string;
};

const LanguageCard: FC<ICheckBoxContainer> = ({ disabled, language }) => {
  const theme = useTheme();

  return (
    <Box>
      <Card
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: 'primary.light',
          borderRadius: '8px',
          shadow: '0 3px 6px 0 0',
          height: '120px',
          width: '132px',
          boxSizing: 'border-box',
          [`${theme.breakpoints.down('md')} and (orientation: landscape)`]: {
            marginTop: '20px',
          },
          [`${theme.breakpoints.down('sm')}`]: {
            marginTop: '10px',
          },
          '&:hover': {
            background: theme.palette.secondary.light,
          },
        }}
      >
        <FormControlLabel
          value={language}
          label={language}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            margin: 0,
            width: '100%',
            height: '100%',
            color: 'text.secondary',
            '.MuiFormControlLabel-label': {
              fontSize: '20px',
            },
          }}
          control={
            <Radio
              value={language}
              checkedIcon={<CheckCircleIcon sx={{ color: 'success.light' }} />}
              icon={<CheckIcon />}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                color: 'text.primary',
                margin: 0,
              }}
            />
          }
        />
      </Card>
    </Box>
  );
};

export default LanguageCard;
